import type { OrderedListProps } from '@/components/landing-page/components/ordered-list';
import clsx from 'clsx';
import { defaults } from '@/components/landing-page/components/ordered-list';
import { cn } from '@/utils/helper';
import v1 from '@/components/landing-page/components/ordered-list/ordered-list-v1.module.css';
import v2 from '@/components/landing-page/components/ordered-list/ordered-list-v2.module.css';

const OrderedList = (props: OrderedListProps) => {
  const { title = defaults.title, list = defaults.list, className = defaults.className } = props;

  return (
    <div className={clsx(cn(v1.OrderedList, v2.OrderedList), className)}>
      <h6 data-testid='ordered-list-title' className={cn(v1.Title, v2.Title)}>
        {title}
      </h6>
      <ol className={cn(v1.List, v2.List)}>
        {list.map((listItem, i) => (
          <li key={i} data-testid='ordered-list-item' className={cn(v1.ListItem, v2.ListItem)}>
            <span className={cn(v1.Bullet, v2.Bullet)}>
              <span>{i + 1}</span>
            </span>
            <span dangerouslySetInnerHTML={{ __html: listItem }} />
          </li>
        ))}
      </ol>
    </div>
  );
};

export default OrderedList;
